module.exports = __webpack_public_path__ + "assets/img/filter-active.86abd806.svg";